module.exports = "//s1.igetcool.com/mall-h5/img/h5_payment_icon_ant_credit@2x.bf7c2893.png";